<!-- @format -->

<register-company-applying-tag>
<h2 class="ui header">法人登録申請</h2>
<div class="ui right aligned basic segment">
  <div class="ui breadcrumb">
    <a href="/menu" class="section">ホーム</a>
    <div class="divider"> / </div>
    <div class="active section">法人登録申請</div>
  </div>
</div>

<div class="ui segment">
  <p>以下の情報で申請中です。審査完了までお待ち下さい</p>
  <div class="ui secondary segment very padded">
    <h4 class="ui dividing header">名称</h4>
    <div class="field">
      <label>会社名</label>
      <div class="fields">
        <div class="eight wide field">
          {params.company_name}
        </div>
      </div>

    </div>
    <div class="field">
      <label>代表者名</label>
      <div class="fields">
        <div class="eight wide field">
          {params.representative}
        </div>
      </div>
      
    </div>

    <h4 class="ui dividing header">連絡先</h4>
    <div class="field">
      <label>本社所在地</label>
      <div class="fields">
        <div class="two wide field">
          {params.zip}
        </div>
        <div class="eight wide field">
          {params.address1}
        </div>
      </div>
      <div class="fields">
        <div class="two wide field">
        </div>
        <div class="eight wide field">
          {params.address2}
        </div>
      </div>
      <div class="fields">
        <div class="three wide field">
          {params.tel}
        </div>
      </div>
    </div>

    <h4 class="ui dividing header">情報</h4>
    <div class="field">
      <label>ホームページ</label>
      <div class="fields">
        <div class="sixteen wide field">
          {params.url}
        </div>
      </div>
      <label>事業内容</label>
      <div class="fields">
        <div class="sixteen wide field">
          <pre>{params.content}</pre>
        </div>
      </div>
      <label>設立</label>
      <div class="fields">
        <div class="one wide field">
          {params.established_year}年
        </div>
        <div class="one wide field">
          {params.established_month}月
        </div>
      </div>
      <label>資本金</label>
      <div class="fields">
        <div class="two wide field">
          {params.capital}万円
        </div>
      </div>

      <label>上場</label>
      <div class="inline fields">
        <div class="field">
          <div if={params.listed == "0"}>非上場</div>
          <div if={params.listed == "1"}>上場</div>
        </div>
      </div>
      <label>法人番号</label>
      <div class="fields">
        <div class="two wide field">
          {params.code}
        </div>
      </div>
    </div>
  </div>
  <button onclick={(e)=>{props.del()}}>消す（開発用）</button>
</div>

<script>
  import di from "dependency-injection";
  export default {
    params: {},
    onBeforeMount(props, state){
      this.params = JSON.parse(props.applyingData.data);
    }
  }
</script>
</register-company-applying-tag>
